import React from 'react'
import { LoginStepSetPassword } from './LoginStepSetPassword'
import { notification } from '../../../components/common/notifications/Notifications'
import { t } from '@lingui/macro'
import { navigateTo } from '../../../app/util/appHistory'
import { linkBuilder } from 'shared/linkBuilder'
import { observer } from 'mobx-react'
import { useLoginContext } from '../login/LoginContext'
import { useSelfSignupMutation } from './set-password.codegen'
import { LoginEmailStep } from '../email/LoginEmailStep'

const useSelfSignUpToOrganisation = () => {
  const ctx = useLoginContext()
  const [fetch] = useSelfSignupMutation()
  return async (): Promise<boolean> => {
    const { data } = await fetch({
      variables: {
        email: ctx.userIdentity,
        password: ctx.password
      }
    })

    return !!data?.selfSignUpToOrganisation
  }
}

export const SetPasswordStep: React.FC = observer(() => {
  const ctx = useLoginContext()
  const selfSignUpToOrganisation = useSelfSignUpToOrganisation()

  const submit = async () => {
    if (await selfSignUpToOrganisation()) {
      navigateTo(linkBuilder.awaitingVerification(ctx.userIdentity))
    } else {
      notification.error(t`Your account could not be created`)
      ctx.setStepView(LoginEmailStep)
    }
  }

  return <LoginStepSetPassword submit={submit} />
})
SetPasswordStep.displayName = 'SetPasswordStep'
